module.exports = __webpack_public_path__ + "static/hhome-vector-e6a952e6f7d24d28be1f4371759ad668.png";